import {RECENT_SEARCH_KEY, RECENT_SEARCH_LIMIT} from '@salesforce/retail-react-app/app/constants';
import {getSessionJSONItem, setSessionJSONItem} from '@salesforce/retail-react-app/app/utils/utils';

/** Persist a search term in session storage (deduped, capped at RECENT_SEARCH_LIMIT). */
export const saveRecentSearch = (searchText) => {
  let searches = getSessionJSONItem(RECENT_SEARCH_KEY) || [];

  searches = searches.filter(
    (savedSearchTerm) => searchText.toLowerCase() !== savedSearchTerm.toLowerCase()
  );
  searches = [searchText, ...searches].slice(0, RECENT_SEARCH_LIMIT);
  setSessionJSONItem(RECENT_SEARCH_KEY, searches);
};
